import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from "react-tooltip";
import jobStatusWidgetType from "./types/jobStatusWidgetType";
import {
  Wrapper,
  ModalTrigger,
  ModalBackdrop,
  ModalWrapper,
  CloseButton,
  Row,
  Top,
  ColumnTitle,
  Bottom,
  ColumnData,
} from "./styles/job-status-widget-styles";

class JobStatusWidget extends Component {
  state = {
    modalShown: false,
  };

  toggleJobStatusWidget = () => {
    const { modalShown } = this.state;
    this.setState({ modalShown: !modalShown });
    document.body.classList.toggle("modalOverlay");
  };

  render() {
    const { modalShown } = this.state;
    const { jobStatusWidget, isRecruiter } = this.props;
    const { applications, interviews, avgResponse } = jobStatusWidget;

    return (
      <Wrapper>
        <ModalTrigger data-tip="See More" data-for="job-status-tooltip">
          <FontAwesomeIcon
            icon={faQuestionCircle}
            onClick={this.toggleJobStatusWidget}
          />
        </ModalTrigger>
        {modalShown && (
          <ModalBackdrop>
            <ModalWrapper>
              <CloseButton onClick={this.toggleJobStatusWidget}>
                <FontAwesomeIcon icon={faTimes} />
              </CloseButton>
              <Row>
                <Top>
                  <ColumnTitle>Active CVs</ColumnTitle>
                  <ColumnTitle>CVs Read</ColumnTitle>
                  <ColumnTitle>Offers Made</ColumnTitle>
                </Top>
                <Bottom>
                  <ColumnData>{applications.submittedCvs}</ColumnData>
                  <ColumnData>{applications.cvsRead}</ColumnData>
                  <ColumnData>{applications.offersMade}</ColumnData>
                </Bottom>
              </Row>
              <Row>
                <Top>
                  <ColumnTitle>Phone Interviews</ColumnTitle>
                  <ColumnTitle>1st Stage Interview</ColumnTitle>
                  <ColumnTitle>2nd Stage Interview</ColumnTitle>
                </Top>
                <Bottom>
                  <ColumnData>{interviews.phoneInterviews}</ColumnData>
                  <ColumnData>{interviews.firstStageInterview}</ColumnData>
                  <ColumnData>{interviews.secondStageInterview}</ColumnData>
                </Bottom>
              </Row>
              <Row>
                <Top>
                  <ColumnTitle>Candidates Rejected</ColumnTitle>
                  <ColumnTitle>Competencies</ColumnTitle>
                  {isRecruiter && avgResponse && (
                    <ColumnTitle>Emp. Avg. Response</ColumnTitle>
                  )}
                </Top>
                <Bottom>
                  <ColumnData>{applications.rejectedCandidates}</ColumnData>
                  <ColumnData>{interviews.competencies}</ColumnData>
                  {isRecruiter && avgResponse && (
                    <ColumnData>{avgResponse}</ColumnData>
                  )}
                </Bottom>
              </Row>
            </ModalWrapper>
          </ModalBackdrop>
        )}
        <ReactTooltip
          place="bottom"
          type="dark"
          effect="solid"
          aria-haspopup="true"
          id="job-status-tooltip"
        />
      </Wrapper>
    );
  }
}

JobStatusWidget.propTypes = {
  jobStatusWidget: jobStatusWidgetType.isRequired,
  isRecruiter: PropTypes.bool.isRequired,
};

export default JobStatusWidget;
